import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys, colors, helpers } from "@clockwise/web-commons/src/styles/color.styles";
// import { weight } from '@clockwise/web-commons/src/styles/type.styles';

const container: CSSProperties = {
  width: "100%",
  display: "flex",
  alignItems: "center",
  padding: "10px 12px",
  "&:hover": {
    background: helpers.opacity(colors.blueCool.lightest, 0.2),
  },
  "& .cw-teammate-delete": {
    visibility: "hidden",
  },
  "&:hover .cw-teammate-delete": {
    visibility: "visible",
  },
  "& .cw-teammate-delete-hidden": {
    visibility: "hidden",
  },
};

const personInfo: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  marginLeft: 12,
};

const name: CSSProperties = {
  fontSize: 16,
  lineHeight: "24px",
  color: greys.standard,
};

const email: CSSProperties = {
  fontSize: 14,
  color: greys.slate,
};

const actionContainer: CSSProperties = {
  display: "flex",
  alignItems: "center",
};

export const suggested: CSSProperties = {
  fontSize: 13,
  marginRight: 20,
};

const textAction: CSSProperties = {
  padding: "0 15px",
  color: greys.slate,
  width: 110,
  textAlign: "center",
};

const tooltip: CSSProperties = {
  maxWidth: 140,
};

export const styles = {
  container,
  personInfo,
  name,
  email,
  actionContainer,
  suggested,
  textAction,
  tooltip,
};
